import { LocalResourcesProgram } from '@kp/local-resources/models/local-resources-program.model';
import { Deserializable, JsonObject } from '@ktypes/models';

export class LocalResourcesSearchItem implements Deserializable<JsonObject, LocalResourcesSearchItem> {
  constructor(public count?: number, public programs?: LocalResourcesProgram[], public zipCode?: string) {}

  deserialize(input: JsonObject): LocalResourcesSearchItem {
    if (input == null) {
      return null;
    }
    this.count = input.count;
    this.programs = input.programs?.map((program) => new LocalResourcesProgram().deserialize(program));
    this.zipCode = input.userZip || input.zipCode; // prefer userZip; zipCode is via server response
    return this;
  }
}
